import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { useCurrentUser } from '@/hooks/use-current-user';
import { useUserPreferences, useUpdatePreferences } from '@/hooks/use-preferences';

const SESSION_STORAGE_KEY = 'cookieConsentResponded';

export function CookieConsentModal() {
  const { t } = useTranslation(['pages.settings']);
  const { user } = useCurrentUser();
  const { data: preferences, isFetched: preferencesFetched } = useUserPreferences({
    enabled: !!user,
  });
  const updatePreferences = useUpdatePreferences();
  const [respondedInSession, setRespondedInSession] = useState(false);

  const hasResponded =
    typeof sessionStorage !== 'undefined' && sessionStorage.getItem(SESSION_STORAGE_KEY) === 'true';

  const shouldShow =
    !!user &&
    preferencesFetched &&
    preferences !== undefined &&
    preferences.cookies !== true &&
    !hasResponded &&
    !respondedInSession;

  useEffect(() => {
    if (respondedInSession && typeof sessionStorage !== 'undefined') {
      sessionStorage.setItem(SESSION_STORAGE_KEY, 'true');
    }
  }, [respondedInSession]);

  const handleAccept = () => {
    setRespondedInSession(true);
    if (typeof sessionStorage !== 'undefined') {
      sessionStorage.setItem(SESSION_STORAGE_KEY, 'true');
    }
    updatePreferences.mutate({ cookies: true });
  };

  const handleDecline = () => {
    setRespondedInSession(true);
    if (typeof sessionStorage !== 'undefined') {
      sessionStorage.setItem(SESSION_STORAGE_KEY, 'true');
    }
    updatePreferences.mutate({ cookies: false });
  };

  return (
    <Dialog open={shouldShow}>
      <DialogContent hideClose className="card-container">
        <DialogHeader>
          <DialogTitle>
            {t('pages.settings:sections.dataProtection.cookieConsent.title')}
          </DialogTitle>
          <DialogDescription>
            {t('pages.settings:sections.dataProtection.cookieConsent.message')}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="gap-2 sm:gap-0">
          <Button variant="outline" onClick={handleDecline} disabled={updatePreferences.isPending}>
            {t('pages.settings:sections.dataProtection.cookieConsent.decline')}
          </Button>
          <Button onClick={handleAccept} disabled={updatePreferences.isPending}>
            {t('pages.settings:sections.dataProtection.cookieConsent.accept')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
